import { render, staticRenderFns } from "./PaperSubmission.vue?vue&type=template&id=2022317c&"
import script from "./PaperSubmission.vue?vue&type=script&lang=js&"
export * from "./PaperSubmission.vue?vue&type=script&lang=js&"
import style0 from "./PaperSubmission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports